export const content = `You can start attending sessions as soon as the next day. Matching with a therapist will depend on your state, insurance, preferences (what you want to discuss, experience, etc.)—and whether therapists that meet those requirements have any openings in the two week window you are shown.

If you’re having trouble finding time with a therapist who meets your needs, you can reach out to our support team at [help@joinuplift.co](mailto:help@joinuplift.co) to consult one of our Matching Specialists.

## How often will I meet with my therapist? Do I have to meet them every week?

You can work together with your therapist to develop a schedule that best suits your needs.
`;
